import { createSlice } from "@reduxjs/toolkit";
import { starBadgeAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const starBadgeSlice = createSlice({
  name: "starBadge",
  initialState: data,
  reducers: {
    starBadgeSlice(state) {
      state.isLoading = false;
    },
    starBadgeSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    starBadgeSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    starBadgeSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const starBadgeHandler = () => async (dispatch: any) => {
  try {
    dispatch(starBadgeAction.starBadgeSlice());
    const response: any = await starBadgeAPI();
    dispatch(starBadgeAction.starBadgeSliceSuccess(response));
  } catch (e: any) {
    dispatch(starBadgeAction.starBadgeSliceFailure(e?.response?.data?.message));
    dispatch(starBadgeAction.starBadgeSliceReset());
  }
};
export default starBadgeSlice.reducer;
export const starBadgeAction = starBadgeSlice.actions;
